import Box from '@mui/material/Box'
import React from 'react'
import { AccordionContext } from './AccordionRoot'

type Props = {
  children: React.ReactNode
  value: string
}
const AccordionItem = ({ children, value }: Props) => {
  const context = React.useContext(AccordionContext)

  const isOpen = context?.open.includes(value)

  const handleToggle = () => {
    if (context) {
      context.toggleOpen(value)
    }
  }

  return (
    <Box sx={{ bgcolor: 'grey.100', borderRadius: 2, mt: 2 }}>
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child as React.ReactElement, {
            isOpen,
            toggleOpen: handleToggle
          })
        }
        return child
      })}
    </Box>
  )
}

export default AccordionItem
